"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _HttpRequest = require("../../../../utils/HttpRequest");

var _AlertHelper = require("../../../../helpers/AlertHelper");

var _APIServiceStrings = require("./APIServiceStrings");

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _BuildConstants = require("../../../../utils/BuildConstants");

var _RegisterInstance = _interopRequireDefault(require("../../../../KESI2/Services/RegisterInstance"));

var PUSH_URI = 'mobile/api/features/v2/sendMessage';
var QUIZZER_PUSH_URI = 'rest/api/v1/equeoqdSendMessage';

var APIService = /*#__PURE__*/function () {
  function APIService() {
    (0, _classCallCheck2["default"])(this, APIService);
  }

  (0, _createClass2["default"])(APIService, null, [{
    key: "sendPush",
    value: function () {
      var _sendPush = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(sender, receiver, message, userAuth) {
        var data, authToUse, token, host, response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                data = {
                  sender: sender,
                  receiver: receiver,
                  message: message
                };
                authToUse = userAuth;

                if (!_config["default"].useDrupalContent) {
                  _context.next = 8;
                  break;
                }

                _context.next = 6;
                return _RegisterInstance["default"].getAccessToken('push:send');

              case 6:
                token = _context.sent;
                authToUse = "Bearer ".concat(token);

              case 8:
                host = _BuildConstants.IS_KESI_APP || _config["default"].useDrupalContent ? _BuildConstants.QUIZZER_HOST : _BuildConstants.HOST;
                _context.next = 11;
                return (0, _HttpRequest.httpPost)("".concat(host, "/").concat(_config["default"].useDrupalContent ? QUIZZER_PUSH_URI : PUSH_URI), data, null, false, null, null, authToUse);

              case 11:
                response = _context.sent;
                console.log('SUCCESS: push sent successfully', response);

                if (response.data.success !== true) {
                  (0, _AlertHelper.showWideAlertHtml)((0, _APIServiceStrings.getString)('PUSH_NOT_SENT'), (0, _APIServiceStrings.getString)('PUSH_ERROR'), true, [{
                    label: 'OK',
                    callback: function callback() {}
                  }]);
                }

                return _context.abrupt("return", _promise["default"].resolve(response));

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](0);
                console.log('ERROR: could not send push', _context.t0);
                (0, _AlertHelper.showWideAlertHtml)((0, _APIServiceStrings.getString)('PUSH_NOT_SENT'), (0, _APIServiceStrings.getString)('PUSH_ERROR'), true, [{
                  label: 'OK',
                  callback: function callback() {}
                }]);
                return _context.abrupt("return", _promise["default"].reject(_context.t0));

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 17]]);
      }));

      function sendPush(_x, _x2, _x3, _x4) {
        return _sendPush.apply(this, arguments);
      }

      return sendPush;
    }()
  }]);
  return APIService;
}();

var _default = APIService;
exports["default"] = _default;